import { timestampToDate } from "../utils"
import genderOptions from "./components/accountCreated/genderOptions"

export default function Reducer(prevState, action){
    switch (action.type) {
        case "LOADING":
            return {
                ...prevState, 
                loading: true
            }
        case "LOADED":
            return {
                ...prevState, 
                loading: false
            }
        case "UPDATE_CURRENT_STEP":
            return {
                ...prevState, 
                step: action.step,
            }
        case "SET_COMMON_SETTINGS":
            return {
                ...prevState, 
                commonSettings: action.commonSettings
            }
        case "SETUP_DETAILS":
            return {
                ...prevState, 
                loading: false,
                step: action.step,
                ftm: {
                    ...action.ftm,
                    ftm_birth_of_date: timestampToDate(action?.ftm?.ftm_birth_of_date),
                    ftm_gender: genderOptions?.find(gender => gender.gender_id === action?.ftm?.ftm_gender)?.gender_id || 0
                },
                isCompletedRegistration: action.isCompletedRegistration,
            }
        default:
            return prevState
    }
}